import { useAuth } from 'app/providers/auth/AuthProvider'

import { SHOW_SERIES } from './series.flags'
import { seriesPagesGate, type SeriesPagesGateState } from './seriesPagesGate'

export const useSeriesPagesGate = (): SeriesPagesGateState => {
  const { hasProfile, hasEmrEnabled } = useAuth()
  return seriesPagesGate({ hasProfile, hasEmrEnabled, showSeries: SHOW_SERIES })
}
